import * as React from 'react';
import { ButtonSecondary, CloseButton } from 'ui';
import styles from './about-modal.scss';

export interface AboutModalProps {
  version: string;
  translation?: any;
  onClose: () => void;
}

export const AboutModal = (props:AboutModalProps) => (
      <div className={`modal ${styles.aboutModal}`}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5>{props.translation.about_title}</h5>
              <CloseButton data-dismiss="modal" onClick={props.onClose}/>
            </div>
            <div className={`modal-body ${styles.aboutModalBody}`}>
              <p className={`${styles.versionInfo}`}>
                <span className={styles.product}>Synergi Life</span> {props.translation.about_info} {props.version}
              </p>
              <p className={`${styles.modalSubtext}`}>&copy; {props.translation.about_copyrights}</p>
            </div>
            <div className={`modal-footer ${styles.aboutModalFooter}`}>
              <ButtonSecondary dataDismiss="modal" onClick={props.onClose}>{props.translation.about_close}</ButtonSecondary>
            </div>
          </div>
        </div>
        <div className="modal-background" onClick={props.onClose}/>
      </div>
    );
